import { Typography } from 'antd';
import React from 'react';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { useReportStore } from '../../stores/ReportStore';
import LoadingModalComponent from '../CommonComponent/LoadingModalComponent';
import FFDBookingFilterReportComponent from './FFDBookingFilterReportComponent ';


function FFDBookingReportComponent() {
    const { promiseInProgress } = usePromiseTracker({ area: 'ffd-booking-report-area' })
    const DownloadFFDBookingReportAction = useReportStore((state) => state?.DownloadFFDBookingReportAction);

    const onDownloadClicked = (data) => {
        trackPromise(DownloadFFDBookingReportAction(data), 'ffd-booking-report-area')
    }
    return (
        <>
            <Typography.Title level={4}> FFD Booking Report </Typography.Title>
            <LoadingModalComponent isLoading={promiseInProgress}>
                <FFDBookingFilterReportComponent 
                onSearchClicked={onDownloadClicked} 
                />
            </LoadingModalComponent>
        </>
    )
}

FFDBookingReportComponent.propTypes = {}

export default FFDBookingReportComponent